import { Action, ActionsList, ContentHeader } from 'components';
import { useTranslation } from 'libs/i18n';
import { ChipOperationStatus } from 'modules/operation/common/components';

import { useOperationContext } from '../../providers/OperationProvider';

import { useOperationFormHeader } from './useOperationFormHeader';

interface OperationFormHeaderProps {
  title: string;
}

export const OperationFormHeader = ({ title }: OperationFormHeaderProps) => {
  const { t } = useTranslation();
  const { operation } = useOperationContext();

  const { editable, actions, onClickOption } = useOperationFormHeader();

  return (
    <ContentHeader
      header={editable ? t('operation.operation.editTitle') : title}
      headerAfterContent={
        <ChipOperationStatus size="m" status={operation.status} />
      }
      rightContent={
        !editable && actions.length > 0 ? (
          <ActionsList>
            {actions.map((action) => (
              <Action
                key={action.value}
                tooltip={action.label}
                onClick={() => onClickOption(action.value)}
              >
                <action.Icon color={action.color} size={16} />
              </Action>
            ))}
          </ActionsList>
        ) : null
      }
    />
  );
};
